
<div>
  <EditableArea
    v-if="mixinEnvironnement_inEditor"
    class="row no-gutters h-100"
    :content="content.row"
    :parentTemplateId="metadata['mgnl:template']"
  >
  </EditableArea>
  <b-container v-else class="conteneur-carrousel p-0">
    <div class="typeTitre">
      <div class="row">
        <div
          class="d-flex justify-content-start col-10"
          :class="{ 'position-texte mw-100': $isMobile() }"
          v-html="content.formatAffichage.titre"
        ></div>
        <div
          v-if="isDesktopOuTablette() && content.row[0].column['@nodes'] != null"
          class="col-2 d-flex justify-content-end"
        >
          <div class="prev mr-1" tabindex="0" @keydown="enterGauche($event)" @click="prev">
            <svg-icon
              class="iconeAvecBordure rotation90 cursor_pointer"
              icon-name="fleche-bas"
              stroke="currentColor"
              fill="$couleur-fond-primaire"
            ></svg-icon>
          </div>
          <div class="next" tabindex="0" @keydown="enterDroite($event)" @click="next">
            <svg-icon
              class="iconeAvecBordure rotation270 cursor_pointer"
              icon-name="fleche-bas"
              stroke="currentColor"
              fill="$couleur-fond-primaire"
            ></svg-icon>
          </div>
        </div>
      </div>
    </div>
    <div v-if="content.row[0].column['@nodes'] == null">
      <Titre
        :content="{
          type: 'typeSousTitre',
          titre: $t('messageComponent.carrouselVide'),
        }"
      ></Titre>
    </div>
    <b-carousel
      v-else
      :id="carrouselId"
      ref="mediaImageCarrousel"
      :interval="parseInt(content.row.carrouselTimer)"
      :controls="false"
      no-animation
      :class="content.formatAffichage.carrouselSize == 'FullScreen' ? 'takeFullWidth' : null"
      @sliding-start="onSlideStart"
    >
      <div
        v-for="(aNode, index) in content.row[0].column['@nodes']"
        :key="aNode.id"
        ref="carrouselItem"
        class="carousel-item"
        @keydown="clavierImages($event)"
        @click="appuyerImages(index)"
      >
        <div class="row align-items-center flex-nowrap takeFullWidth">
          <template v-for="(aNode, idx) in content.row[0].column['@nodes']">
            <component
              :is="
                content.row[0].column[
                  content.row[0].column['@nodes'][
                    (index + idx) % content.row[0].column['@nodes'].length
                  ]
                ].format
              "
              v-if="content.row[0].column[aNode].format"
              :ref="idx == getIndexOfMiddleImg ? 'imgToCenter' : 'imgWithoutText'"
              :key="
                content.row[0].column[
                  content.row[0].column['@nodes'][
                    (index + idx) % content.row[0].column['@nodes'].length
                  ]
                ]['@id']
              "
              tabindex="0"
              class="container"
              :class="idx == getIndexOfMiddleImg ? 'pb-0' : 'pt-0 mt-n1'"
              :style="
                idx == getIndexOfMiddleImg
                  ? '!important; margin-right: calc(0.45 * -2rem); margin-left: calc(0.45 * -2rem);'
                  : 'padding-right: calc(1.45 * 2rem) !important; padding-left: calc(1.45 *   2rem) !important; margin-right: calc(1.25 * -2rem); margin-left: calc(1.25 * -2rem);'
              "
              :content="
                content.row[0].column[
                  content.row[0].column['@nodes'][
                    (index + idx + longueurReajustee) % content.row[0].column['@nodes'].length
                  ]
                ]
              "
            >
            </component>
          </template>
        </div>
      </div>
    </b-carousel>
  </b-container>
</div>
